import { render, staticRenderFns } from "./create_new.vue?vue&type=template&id=3a66923d&scoped=true"
import script from "./create_new.vue?vue&type=script&lang=js"
export * from "./create_new.vue?vue&type=script&lang=js"
import style0 from "./create_new.vue?vue&type=style&index=0&id=3a66923d&prod&scoped=true&lang=css"
import style1 from "./create_new.vue?vue&type=style&index=1&id=3a66923d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a66923d",
  null
  
)

export default component.exports